import { path } from "ramda";

export function populateOrderedSchema(
  outcome: any,
  orderedProp: any,
  parents: string[] = [],
) {
  if (
    orderedProp.type === "object" &&
    Array.isArray(orderedProp.orderedProperties)
  ) {
    const mappedOrderedProperties = orderedProp.orderedProperties.map(
      (subOrderedProp) =>
        populateOrderedSchema(outcome, subOrderedProp, [
          ...parents,
          orderedProp.name,
        ]),
    );

    return { ...orderedProp, orderedProperties: mappedOrderedProperties };
  }

  const keyPath = [...parents, orderedProp.name].filter(Boolean);
  const value = path(keyPath, outcome);

  return { ...orderedProp, value };
}
